import { FC, useState, useCallback, useEffect } from 'react';
import { TextField, Grid } from '@mui/material';
import { AdvertisementService } from 'services';
import { Button } from 'components';
import { IAdvertisementList } from 'types/Advertisement';

interface ISearch {
  setAdvertisements: Function;
  currentPage: number;
  setMaxPage: Function;
  setLoading: Function;
}

export const SearchBar: FC<ISearch> = ({
  setAdvertisements,
  currentPage,
  setMaxPage,
  setLoading,
}) => {
  const [query, setQuery] = useState('');
  const [inPage, setInPage] = useState(currentPage);

  const getAdvertisements = useCallback(async (page: number, filter: string) => {
    const advertisements = await AdvertisementService.getAdvertisementList(page, 10, filter);
      if (advertisements.status === 200) {
        setMaxPage(advertisements.data.totalPages);
        return advertisements.data;
      } else {
        return [];
      }
    }, 
    [setMaxPage]
  );

  const getAdvertisementsCb = useCallback(
    async (force = false) => {
      if (inPage !== currentPage || force === true) {
        const advertisements = await getAdvertisements(currentPage, query);
        setAdvertisements(advertisements);
      }
    },
    [setAdvertisements, inPage, query, currentPage, getAdvertisements]
  );

  useEffect(() => {
    getAdvertisements(1, '').then((advertisements: IAdvertisementList) => {
      setLoading(false);
      setAdvertisements(advertisements);
      setMaxPage(advertisements.totalPages);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setAdvertisements, setLoading, getAdvertisements]);

  useEffect(() => {
    setInPage(currentPage);
  }, [currentPage, setInPage, getAdvertisementsCb]);

  useEffect(() => {
    getAdvertisementsCb();
  }, [setInPage, getAdvertisementsCb]);

  return (
    <Grid container spacing={1} justifyContent="flex-end">
      <Grid item>
        <TextField
          id="query"
          label="Parceiro"
          variant="outlined"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />
      </Grid>
      <Grid item>
        <Button
          size="large"
          sx={{ minHeight: 56, color: '#FFF' }}
          onClick={() => getAdvertisementsCb(true)}
        >
          Buscar
        </Button>
      </Grid>
    </Grid>
  );
};

